(function() {

    'use strict';

    angular.module('app').
    controller('DriverDetailsModalController', DriverDetailsModalController);

    DriverDetailsModalController.$inject = ['$scope','ManifestService', '$uibModalInstance','data','toastr'];

    function DriverDetailsModalController( $scope,ManifestService,$uibModalInstance,data,toastr) {

        const vm = this;
        vm.driverDetails = angular.copy(data)
        vm.closeModal = modalClose;
        vm.download = download;
        vm.driverDetails.createdDate = new Date(vm.driverDetails.createdDate).getTime()
        angular.forEach(vm.driverDetails.truckDriverAuditShipmentDetailSet,function(item){
            vm.driverDetails.truckDriverAuditShipmentDetailSet.manifestNo = item.manifestNo;
            vm.driverDetails.shipmentId = item.shipmentId;
        })
        function modalClose() {
            $uibModalInstance.dismiss();
        }

        function download(){
            ManifestService.downloadProofOfSignature(
                res=>{
                    angular.forEach(res,function(item){
                        window.open(item)
                    })
                },
                err=>{
                    console.log(err)
                    toastr.warning('No image uploaded!','Warnning')
                },
                {shipmentId:vm.driverDetails.shipmentId}
            )
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/manifests/modal/driverDetailsModalController.js